"use client";

import React, { ReactNode, useEffect } from 'react';

export function IsSelectedDebugger() {
  useEffect(() => {
    // Function to patch React's createElement to detect isSelected props
    const patchReactCreateElement = () => {
      const originalCreateElement = React.createElement;

      // Type the function parameters and cast the result to match React's signature
      const newCreateElement = function(
        this: unknown,
        type: React.ElementType,
        props?: Record<string, any> | null,
        ...children: ReactNode[]
      ) {
        // Only check DOM elements (string types) and only log warnings, don't break execution
        if (typeof type === 'string' && props && 'isSelected' in props) {
          console.warn(
            `React does not recognize the 'isSelected' prop on a DOM element: <${type}>`,
            'Component props:', props
          );
        }

        try {
          // Always return the result of the original createElement function
          return originalCreateElement.apply(this, [type, props, ...children]);
        } catch (error) {
          console.error('Error in patched React.createElement:', error);
          // Safely fall back to original implementation if our patch causes issues
          if (typeof type === 'string') {
            console.warn('Fallback: creating element without special handling for:', type);
            // Filter out invalid props for DOM elements (like 'isSelected')
            if (props) {
              const safeProps = { ...props };
              if ('isSelected' in safeProps) {
                delete safeProps.isSelected;
              }
              return originalCreateElement.call(this, type, safeProps, ...children);
            }
          }
          // Last resort fallback
          return originalCreateElement.apply(this, [type, props, ...children]);
        }
      };

      // Type assertion to inform TypeScript this matches React's createElement
      React.createElement = newCreateElement as typeof React.createElement;

      return () => {
        React.createElement = originalCreateElement;
      };
    };

    // Apply the patch
    const cleanup = patchReactCreateElement();

    return cleanup;
  }, []);

  return null; // This component doesn't render anything
}
